import "./App.css";
import Routes from "./Routes";
import React from "react";

function App() {
  return (
    <>
      <Routes />
    </>
  );
}

export default App;
